import React from 'react';
interface IProps { 
    text: string, 
    maxLength: number
}

const TruncatedText = (props: IProps) => {
const {text, maxLength} = props;
  if (text.length <= maxLength) {
    return <span>{text}</span>;
  } else {
    return (
      <div className="truncate-text" title={text}>
        {text.slice(0, maxLength)}...
      </div>
    );
  }
};

export default TruncatedText;
